import { DialogBody } from "@blueprintjs/core";
import React from "react";

import { Tag as TTag } from "../../redux/slices";
import { Button } from "../Button/button";
import { Modal } from "../modal/modal";
import { Tag } from "../tag/tag";

export interface DeleteTagModalProps {
  show: boolean;
  handleClose: (e: any) => void;
  tag: TTag;
  handleDeleteTag: (e: any) => void;
}

export const DeleteTagModal = ({ show, handleClose, tag, handleDeleteTag }: DeleteTagModalProps) => {
  return (
    <Modal
      title="Delete Series"
      isOpen={show}
      onClose={handleClose}
      actions={[
        <Button minimal={true} text="Cancel" onClick={handleClose} key={2} />,
        <Button intent="danger" text="Delete" onClick={handleDeleteTag} key={1} />,
      ]}
    >
      <DialogBody>
        <div>
          Are you sure you want to delete <Tag tag={tag} />?
        </div>
      </DialogBody>
    </Modal>
  );
};
